export default __webpack_public_path__ + "static/media/plano_midias_on_off.d975c361.png";